<template lang="html">
  <div class="cw-tag-input">
    <div class="field is-grouped is-grouped-multiline">
      <div v-for="(tag, i) in tags" :key="tag" class="control">
        <div class="tags has-addons">
          <a class="tag is-medium is-link">{{ tag }}</a>
          <a class="tag is-medium is-delete" @click="remove(i)"></a>
        </div>
      </div>
    </div>
    <section class="section centerit is-horizontal">
      <div class="centerit-body">
        <form class="form" @submit="addNew">
          <div class="field has-addons">
            <div class="control">
              <input
                type="text"
                class="input is-underlined is-medium"
                placeholder="Email Address"
                v-model="newTag"
              />
              <p v-if="helpVisible" class="help is-medium">{{ helpText }}</p>
            </div>
            <a class="button is-light" @click="addNew()">
              Add
            </a>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */
const validators = {
  email: new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ),
  url: new RegExp(
    /^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i
  ),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(
    /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/
  ),
};

export default {
  name: 'cw-tag-input',
  // share common functionality with component mixins
  mixins: [],
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    onChange: {
      type: Function,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newTag: '',
      helpText: '',
      helpVisible: false,
    };
  },
  methods: {
    focusNewTag() {
      if (this.readOnly) {
        return;
      }
      this.$el.querySelector('.new-tag').focus();
    },
    addNew(e) {
      if (e) e.preventDefault();
      let tag = this.newTag;
      if (this.tags.indexOf(tag) !== -1) {
        this.showHelp('Already added');
        return false;
      }
      if (!this.validateIfNeeded(tag)) {
        this.showHelp(`Invalid ${this.validate}`);
        return false;
      }

      this.tags.push(tag);
      this.tagChange();
      this.newTag = '';
      return true;
    },
    validateIfNeeded(tagValue) {
      if (this.validate === '' || this.validate === undefined) {
        return true;
      } else if (Object.keys(validators).indexOf(this.validate) > -1) {
        return validators[this.validate].test(tagValue);
      }
      return true;
    },
    showHelp(help) {
      this.helpText = help;
      this.helpVisible = true;
      setTimeout(() => {
        this.helpVisible = false;
      }, 2000);
    },
    remove(index) {
      this.tags.splice(index, 1);
      this.tagChange();
    },
    removeLastTag() {
      if (this.newTag) {
        return;
      }
      this.tags.pop();
      this.tagChange();
    },
    tagChange() {
      if (this.onChange) {
        // avoid passing the observer
        this.onChange(JSON.parse(JSON.stringify(this.tags)));
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
